// extracted by mini-css-extract-plugin
module.exports = {"indigo":"title_indigo__2Vl-m","night":"title_night__1pVwN","title":"title_title__3u9El"};